// TODO: Add video and image to message instead of method
import { Component, HostBinding, inject, Input, type OnInit } from '@angular/core';
import { ChatCoreBotMessageComponent, ChatService, type Config } from '@big-direkt/chat-core';
import { IconBigMediumChatbot, IconBigMediumHinweis } from '@big-direkt/utils/icons';
import { type BehaviorSubject } from 'rxjs';

@Component({
    selector: 'big-chat-bot-message',
    templateUrl: './message.component.html',
    styleUrl: './message.component.scss',
    standalone: false,
})
export class MessageComponent extends ChatCoreBotMessageComponent implements OnInit {
    public readonly iconHint = IconBigMediumHinweis;
    public readonly iconChatBot = IconBigMediumChatbot;

    private readonly chatService = inject(ChatService);

    @HostBinding('class') @Input() public classList = 'block';

    public config!: BehaviorSubject<Config>;

    public ngOnInit(): void {
        this.config = this.chatService.getConfig();
    }
}
